import React from "react";
import ChildComponent from './child.js'
import { v4 as uuidv4 } from 'uuid';

export default class HouseholdComponent extends React.Component {
    constructor(props) {
        super(props);
        this.HouseholdData = this.props.data;
        this.OwnHousehold = this.props.ownHousehold;
        this.state = {
            sharingLink: '',
            householdData: this.HouseholdData,
        };
    }
    
    handleAddChild = () => {
      this.HouseholdData.Children.push({ HouseholdId: this.HouseholdData.HouseholdId, ChildId: uuidv4(),  Name: "", DislikedFoods: [], FavoriteFoods: [], BedtimeRoutine: [], Restrictions: [] });      
      this.setState({householdData: this.HouseholdData});
    };

    handleShareClick = () => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/shareHouseholdInfo`, {
          method: 'POST',
          credentials: 'include',
          body: JSON.stringify({ householdId: this.HouseholdData.HouseholdId , numDays: 1}),
        })
          .then(response => response.json())
          .then(data => {
            if (data.link) {
              this.setState({ sharingLink: data.link }, () => {
                // copy to clipboard
                const textField = document.createElement('textarea');
                textField.innerText = this.state.sharingLink;
                document.body.appendChild(textField);
                textField.select();
                document.execCommand('copy');
                textField.remove();
              });
            }
          })
          .catch(error => console.error('Error sharing household info:', error));
      };

    render() {
        return (
            <div>
              <h2>{this.HouseholdData.Name} Household</h2>
              <p><strong>Address:</strong><a target='new' href={"https://maps.google.com/maps?q=" + encodeURI(this.HouseholdData.Address)}>{this.HouseholdData.Address}</a></p>
              <h3>Guardians</h3>
              <table className='househould-table'>
              <tbody>
                <tr>
                  {this.HouseholdData.Guardians.map(guardian => (
                    <td key={guardian.Email} style={{ verticalAlign: 'top', padding: '10px', textAlign: 'center' }}>
                      <p style={{ fontWeight: 'bold' }}>{guardian.Name}</p>
                      <p style={{ fontWeight: 'bold' }}>Phone Number:</p>
                      <p style={{ fontSize: '0.9em' }}>{guardian.PhoneNumber}</p>
                      <p style={{ fontWeight: 'bold' }}>Email:</p>
                      <a href={`mailto:${guardian.Email}`} style={{ fontSize: '0.9em' }}>{guardian.Email}</a>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>        
            <h3>Children</h3>
            <table className='househould-table'>
              <tbody>
              <tr>
                {            
                  this.HouseholdData.Children.map((child, index) => (
              <td key={"td-"+ index}><ChildComponent key={uuidv4()} child={child} index={index} ownHousehold={this.OwnHousehold}/></td>
            ))}            
             {this.OwnHousehold && (<td><button onClick={this.handleAddChild}>Add Child</button></td>)}
                </tr>
              </tbody>
            </table>
            
            {this.OwnHousehold && (
            <>
                <button onClick={this.handleShareClick}>Share Household Info</button>
                {this.state.sharingLink && (
                <>
                    <p>Sharing Link Copied to Clipboard!</p>
                    <textarea value={this.state.sharingLink} readOnly={true} />
                </>
                )}
            </>
            )}            
            </div>
          );
    }  
}